import { STATUS_LABELS } from "./constants";

export function transformProject(row) {
  return {
    id:                 row.id,
    sortOrder:          row.sort_order,
    slug:               row.slug,
    seoTitle:           row.seo_title,
    seoDescription:     row.seo_description,
    title:              row.title,
    status:             row.status,
    statusLabel:        STATUS_LABELS[row.status] ?? row.status,
    location:           row.location,
    year:               row.year,
    units:              row.units,
    area:               row.area,
    type:               row.type,
    address:            row.address,
    coordinates:        (row.lat != null && row.lng != null)
                          ? [Number(row.lat), Number(row.lng)]
                          : null,
    shortDescription:   row.short_description,
    description:        row.description,
    coverImage:         row.cover_image,
    coverVideo:         row.cover_video        ?? undefined,
    coverVideoPoster:   row.cover_video_poster ?? undefined,
    gallery:            row.gallery            ?? [],
    features:           row.features           ?? [],
    technicalDetails:   row.technical_details  ?? {},
    nearby:             row.nearby             ?? [],
    materialHighlights: row.material_highlights ?? [],
    floorPlans:         row.floor_plans        ?? [],
    isPublished:        row.is_published,
  };
}
